export default {
  name: 'bookings/details',
}
